import { Drawer, Tag } from 'antd';
import styled from 'styled-components';

export const StyledCheckableTag = styled(Tag.CheckableTag)<{ $checked: boolean }>`
  border: 1px solid ${({ $checked }) => ($checked ? '#b7eb8f' : '#666')};
  background: ${({ $checked }) => ($checked ? '#f6ffed' : '#fff')};
  color: ${({ $checked }) => ($checked ? '#389e0d' : '#666')};
  transition: all 0.2s;
  font-weight: 500;
  margin-bottom: 5px;

  &:hover {
    border-color: ${({ $checked }) => ($checked ? '#b7eb8f' : '#666')} !important;
    color: ${({ $checked }) => ($checked ? '#389e0d' : '#666')} !important;
    background: ${({ $checked }) => ($checked ? '#f6ffed' : '#fff')} !important;
    box-shadow: ${({ $checked }) =>
      $checked ? '0 0 0 2px rgba(183, 235, 143, 0.5)' : '0 0 0 2px rgba(0, 0, 0, 0.1)'} !important;
  }

  &:active,
  &:focus {
    border-color: ${({ $checked }) => ($checked ? '#b7eb8f' : '#666')} !important;
    color: ${({ $checked }) => ($checked ? '#389e0d' : '#666')} !important;
    background: ${({ $checked }) => ($checked ? '#f6ffed' : '#fff')} !important;
    box-shadow: none !important;
  }
`;

export const FlowMainPanel = styled.div`
  padding: 0 5px 5px 0;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;

  .title {
    margin-right: 10px;
  }

  sup {
    color: #999;
  }
`;

export const ManageFooter = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-close {
    height: auto;
    width: auto;
    position: relative;
  }

  .ant-drawer-body {
    padding: 15px;
    overflow: hidden;
    display: flex !important;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .ant-card-meta-title {
    font-weight: 400;
    font-size: 12px;
    white-space: wrap;
  }
`;

export const FlowBox = styled.div<{ $isSelected: boolean }>`
  cursor: pointer;
  border: 1px solid ${({ $isSelected }) => ($isSelected ? '#0958d9' : '#eee')};
  border-radius: 8px;
  margin: 10px 5px;
  background: ${({ $isSelected }) => ($isSelected ? '#f2f5ff' : '#fff')};
  transition:
    border 0.2s,
    background 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`;

export const StyledBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  transition: box-shadow 0.2s;
`;

export const FlowContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FlowName = styled.div`
  font-size: 14px;
  color: #222;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FlowLabels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const FlowLabel = styled.span`
  display: inline-block;
`;

export const FlowTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  justify-content: space-between;

  .flow-drawer-title {
    color: #a1a1a1;
  }

  .ant-drawer-header-title {
    flex-direction: row-reverse;

    .ant-drawer-title {
      font-size: 22px;
      font-weight: 400;
    }
  }
`;

export const SectionHeader = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  color: #666;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 20px;
  color: #999;
`;

export const DrawerCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;
